
import React, { useEffect, useState } from "react";

// Chakra imports
import {
    Box,
    Button,
    Flex,
    Grid,
    Link,
    Text,
    useColorModeValue,
    SimpleGrid,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Stack,
    Alert,
    IconButton,
    AlertIcon
} from "@chakra-ui/react";

// Custom components
import ItemWhitelist from "views/admin/suspicious/components/ItemWhitelist";
import CommentPopover from "./CommentPopover";
import Card from "components/card/Card.js";
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { useListContext } from '../../../../contexts/listContext';
import { useProductStore } from "../../../../store/useProductStore";
import Loader from "../../../../components/loader/Loader";
import Title from "services/Title";
import { MdViewList, MdViewModule, MdCheckCircle, MdCancel, MdDelete, MdShoppingCart, MdOutlineError } from "react-icons/md";
import useRelevanceChanges from "hooks/useRelevanceChanges";




export default function Reported(props) {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const { userId, reportedProducts, isAdmin, isLoading } = props;
    // Chakra Color Mode
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const textColorBrand = useColorModeValue("brand.500", "white");
    const [productsToShow, setProductsToShow] = useState(20); // Initial number of products to show
    const productsPerPage = 20; // Number of products to load per page
    const [showLoadMore, setShowLoadMore] = useState(true);
    const {
        relevanceChanges,
        handleInsertRelevance,
        clearRelevanceChanges
    } = useRelevanceChanges();
    const [updateSeller, setUpdateSeller] = useState([])
    const [searchedProds, setSearchedProds] = useState([]);
    const { list, checkedPlatforms, abuse_type, dateFilter, checkedAbuseTypes } = useListContext();
    const [statusUpdate, setStatusUpdate] = useState(false);
    const [sortedProducts, setSortedProducts] = useState([]);
    const [savingChanges, setSavingChanges] = useState(false)
    const { products, moveProducts, updateProducts ,fetchProductsByStatus: storeFetchProductsByStatus,updateProductFields } = useProductStore();

    const [viewMode, setViewMode] = useState("grid")
    const [successAlert, setSuccesAlert] = useState('');
    const [failureAlert, setFailureAlert] = useState('');

    const handleSuccessAlert = async (alertMessage) => {
        setSuccesAlert(alertMessage);
        setTimeout(() => {
            setSuccesAlert('');
        }, 5000);
    }
    const handleFailureAlert = async (alertMessage) => {
        setFailureAlert(alertMessage);
        setTimeout(() => {
            setFailureAlert('');
        }, 5000);
    }


    const loadMore = () => {
        setProductsToShow(productsToShow + productsPerPage);
    };
    const loadLess = () => {
        setProductsToShow(productsToShow - productsPerPage);
    };

    const handleUpdateSeller = async (product, seller_status) => {
        try {
            setUpdateSeller(prev => {
                const existingIndex = prev.findIndex(item => item.product.psm_id === product.psm_id);

                if (existingIndex !== -1) {
                    const updatedSeller = [...prev];
                    updatedSeller[existingIndex].seller_status = seller_status;
                    return updatedSeller;
                }

                return [...prev, { product, seller_status }];
            });
        } catch (err) {
            console.error('err in handleInserSeller', err)
        }
    }

    const removeFromUpdate = async (product, seller_status) => {
        setUpdateSeller(prev => prev.filter((item) => {
            return !(item.product.psm_id === product.psm_id);
        }));
    }

    const handleSaveChanges = async () => {
        try {
            let productsToRemove = [];
            setSavingChanges(true)
                    if (isAdmin) {

            const uid = JSON.parse(localStorage.getItem("PAuser")).message.result.id;
            const response = await fetch(
                `${backendUrl}/api/sellers/updateSellerStatus/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        sellers: updateSeller,
                        uid: uid,
                    }),
                }
            );

            const json = await response.json();

            if (response.ok) {
                for (const item of updateSeller) {
                    const { product, seller_status } = item;
                    let targetCategory = null;

                    if (seller_status === "T") {
                        targetCategory = "testPurchase";
                    } else if (seller_status === 'TD') {
                        targetCategory = "takenDown";
                    } else if (seller_status === 'NC') {
                        targetCategory = "nonCompliance";
                    } else if (seller_status === 'W') {
                        targetCategory = "whitelisted";
                    } else if (seller_status === 'NR') {
                        targetCategory = "nonReportable";
                    }

                    if (targetCategory) {
                        const updatedProducts = await moveProducts("reported", [product], targetCategory);
                        await handleFilter(updatedProducts);
                    }
                }
                handleSuccessAlert("Changes Saved");
                setUpdateSeller([]);
                setStatusUpdate(true);
            } else if (response.status === 400) {
                handleFailureAlert("Error saving changes");
                setStatusUpdate(true);
            }
            setStatusUpdate(true);
        }
            if (relevanceChanges.length > 0) {

                const relevanceResponse = await fetch(
                    `${backendUrl}/api/products/updateRelevance`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            products: relevanceChanges,
                        }),
                    }
                );

                if (!relevanceResponse.ok) {
                    handleFailureAlert("Failed to update relevance");
                    return;
                }
                handleSuccessAlert("Changes Saved Successfully ")
            }
            clearRelevanceChanges();
             
        
        } catch (e) {
            handleFailureAlert("Error saving changes");
        } finally {
            setSavingChanges(false)
        }
    };

    // Update handleSearch to set sortedProducts instead of searchedProds
    const handleSearch = async (text) => {
        try {
            if (text) {
                setSortedProducts(products["reported"].filter((item) =>
                    item.title?.toLowerCase().includes(text?.toLowerCase()) ||
                    item.keyword?.toLowerCase().includes(text?.toLowerCase()) ||
                    item.seller_name?.toLowerCase().includes(text?.toLowerCase()) ||
                    item.prod_code?.toLowerCase().includes(text?.toLowerCase())
                ));
            } else {
                setSortedProducts(products["reported"]);
                handleFilter();
            }
        } catch (e) {
            console.error('error in search', e)
        }
    }
    // Add filter effect
    useEffect(() => {
        handleFilter();
        // fetchProductsByStatus("R")
    }, [list, checkedPlatforms, checkedAbuseTypes, dateFilter, products["reported"]]);

    const handleFilter = async (productSource = products) => {
        try {
            let keywordId = list.map((item) => item.id);
            let platformIds = checkedPlatforms.map((item) => item.id);
            let abuseTypeId = checkedAbuseTypes;
            let allProducts = productSource["reported"] || [];

            let kfilter = allProducts.filter((item) =>
                keywordId?.includes(item.keyword_id)
            );

            console.log("kfilter", kfilter)

            let pfilter = kfilter.filter((item) =>
                platformIds?.includes(item.platform_id)
            );

            let afilter = pfilter.filter((item) =>
                abuseTypeId?.includes(item.abuse_type_id) || item.abuse_type_id === null
            );

            let startDate = new Date(dateFilter.startDate);
            let endDate = new Date(dateFilter.endDate);
            endDate.setHours(23, 59, 59, 999);

            let dateSort = await afilter.filter((item) => {
                if (item.date_report === undefined) {
                    item.date_report = new Date().toLocaleDateString();
                }
                let date = new Date(item.date_report);

                return date >= startDate && date <= endDate;
            });

            setSearchedProds(dateSort);
            setSortedProducts(dateSort);
        } catch (err) {
            console.error("error in handleFilter", err);
        }
    };



    return (
        <Box >
            {/* Main Fields */}
            {(isLoading || savingChanges) && <Loader />}

            <Card p='0px' w='100%'>
                <Flex justify={"space-between"} m={2}>

                    <Text px='20px' pt='10px'>Count: {sortedProducts.length}</Text>
                    <Flex gap={2}>
                        <IconButton size="md" icon={<MdViewList />} isActive={viewMode === 'list'} onClick={() => setViewMode('list')} />
                        <IconButton size="md" icon={<MdViewModule />} isActive={viewMode === 'grid'} onClick={() => setViewMode('grid')} />

                    </Flex>
                </Flex>

                <Flex
                    align={{ sm: "flex-start", lg: "center" }}
                    justify='space-between'
                    w='100%'
                    px='22px'
                    py='18px'>
                    <SearchBar m="10px" borderRadius="30px" onChange={(e) => handleSearch(e.target.value)} />
                    {(isAdmin || relevanceChanges.length > 0) && (

                        <Button variant='action' alignSelf='right' onClick={() => handleSaveChanges()}>Save Changes</Button>
                    )}
                </Flex>
                <SimpleGrid columns={viewMode === 'grid' ? { base: 1, md: 3, xl: 4 } : 1} spacing={3}>

                    {sortedProducts?.slice(0, productsToShow).map((prod, index) => {
                        return (
                            <ItemWhitelist
                                key={prod.psm_id ?? prod.pd_id}
                                index={index}
                                product={prod}
                                handleUpdateSeller={handleUpdateSeller}
                                removeFromUpdate={removeFromUpdate}
                                statusUpdate={statusUpdate}
                                setStatusUpdate={setStatusUpdate}
                                isAdmin={isAdmin}
                                viewMode={viewMode}
                                abuseTypes={abuse_type}
                                handleInsertRelevance={handleInsertRelevance}
                                actionMode="reported"
                            />
                        )
                    })}
                </SimpleGrid>
            </Card>

            <Stack spacing={3} position='fixed' right='10px' bottom='2vh'>
                {successAlert !== '' &&
                    <Alert status='success' variant='left-accent' w='40vw'  >
                        <AlertIcon />
                        {successAlert}

                    </Alert>
                }
                {failureAlert !== '' &&
                    <Alert status='error' variant='left-accent' w='40vw'>
                        <AlertIcon />
                        {failureAlert}
                    </Alert>
                }
            </Stack>

            <Link ><Text color={textColor} fontSize='l' fontWeight='500' onClick={() => loadLess()} r='0' position='absolute' right={{ base: '10%', md: '15%', sm: '30%' }} textDecoration='underline'>
                Show less...
            </Text></Link>
            <Link ><Text color={textColor} fontSize='l' fontWeight='500' onClick={() => loadMore()} r='0' position='absolute' right={{ base: '2%', md: '5%' }} textDecoration='underline'>
                Show more...
            </Text></Link>
            {/* Delete Product */}
        </Box>
    );
}
